/* eslint-disable @typescript-eslint/no-shadow,prefer-arrow/prefer-arrow-functions */
import { get } from 'lodash'
import { authenticateAgainstPartnerSSO } from '@/services/auth'
import { AuthXUserIdentityToken } from '@/types'

interface PartnerStoreState {
  authXUserIdentityToken: AuthXUserIdentityToken | null
}

const state: PartnerStoreState = {
  authXUserIdentityToken: null,
}

const getters = {

  partnerUserIdentity(state: PartnerStoreState): PartnerStoreState['authXUserIdentityToken'] {
    return get(state, 'authXUserIdentityToken')
  },

  tenantCode(state: PartnerStoreState): string {
    return get(state, 'authXUserIdentityToken.tenantCode')
  },

  token(state: PartnerStoreState): string {
    return get(state, 'authXUserIdentityToken.token')
  },

}

const mutations = {
  storeAuthXUserIdentityToken(state: PartnerStoreState, payload: PartnerStoreState['authXUserIdentityToken']) {
    state.authXUserIdentityToken = payload
  },
}

const actions = {
  authenticate({ commit }, args: { partnerCode: string, token: string }) {
    return authenticateAgainstPartnerSSO(args.partnerCode, args.token).then((payload) => {
      commit('storeAuthXUserIdentityToken', payload)
    })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
